import { DENOMINATIONS, countOf, denominationLabel } from '../utils/denominations';
import { DenominationIcon } from './CashDenominationInput';

/**
 * ฝั่ง "รับเงินมา" — แตะรูปแบงก์/เหรียญโดยตรงแทนกด +/− ทีละครั้ง (แตะ = +1 แบงก์ที่ลูกค้ายื่นมาจริง)
 * เจตนา: ปุ่มลัดเดา breakdown จากยอดรวม (breakdownChange) ทำให้ข้อมูลแบงก์ในลิ้นชักไม่ตรงกับที่
 * ลูกค้าให้จริง — ตัดปุ่มลัดทิ้งไปแล้ว (ดู Checkout.jsx) เหลือแค่ทางนี้ทางเดียวในการกรอกฝั่งรับมา
 * ฝั่ง "ทอนไป" ยังใช้ CashDenominationInput (stepper แบบเดิม) อยู่ เพราะพนักงานเลือกเองว่าจะทอน
 * เป็นแบงก์อะไร ไม่ใช่ "แตะแบงก์ที่ลูกค้ายื่นมา" แบบฝั่งนี้ — สองฝั่งจึงเป็นคนละ interaction กัน
 */
export default function CashDenominationTapGrid({ counts, onChange }) {
  const setCount = (value, n) => onChange({ ...counts, [String(value)]: String(Math.max(0, n)) });
  const ordered = [...DENOMINATIONS].reverse();
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(72px, 1fr))', gap: '0.6rem' }}>
      {ordered.map(d => {
        const n = countOf(counts, d.value);
        return (
          <div key={d.value} style={{ position: 'relative' }}>
            <button
              type="button"
              aria-label={denominationLabel(d)}
              title={denominationLabel(d)}
              onClick={() => setCount(d.value, n + 1)}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0.6rem 0.4rem',
                background: 'var(--surface-2, #1f232c)',
                border: n > 0 ? '2px solid var(--text, #eceef3)' : '1px solid var(--border-strong, #2c3140)',
                borderRadius: '10px',
                cursor: 'pointer'
              }}
            >
              <DenominationIcon value={d.value} />
            </button>
            {n > 0 && (
              <>
                <span
                  aria-hidden="true"
                  style={{
                    position: 'absolute', top: '-8px', right: '-8px',
                    background: '#667eea', color: 'white', borderRadius: '999px',
                    fontSize: '11px', fontWeight: 700, padding: '2px 6px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.25)', pointerEvents: 'none'
                  }}
                >
                  ×{n}
                </span>
                <button
                  type="button"
                  aria-label={`${denominationLabel(d)} ลด (กดพลาด)`}
                  onClick={(e) => { e.stopPropagation(); setCount(d.value, n - 1); }}
                  style={{
                    position: 'absolute', top: '-8px', left: '-8px',
                    width: '22px', height: '22px', borderRadius: '50%',
                    border: '1px solid var(--border-strong, #2c3140)', background: 'var(--surface, #171a21)', color: 'var(--danger, #ef5b5b)',
                    fontSize: '14px', fontWeight: 700, lineHeight: 1, cursor: 'pointer',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.35)'
                  }}
                >
                  −
                </button>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
